import { render, staticRenderFns } from "./SolicitorDocuments.vue?vue&type=template&id=38d081e1"
import script from "./SolicitorDocuments.vue?vue&type=script&lang=js"
export * from "./SolicitorDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports